import { Component, Input } from "@angular/core";
import { UserAPI } from "../../../../model";
import { AbstractUserApiModalComponent } from "../../abstract-userapi-modal.component";

@Component({
  standalone: false,
  selector: 'app-userapi-oauth-with-custom-url',
  templateUrl: './userapi-oauth-with-custom-url.component.html'
})
export class UserApiOAuthWithCustomUrlComponent extends AbstractUserApiModalComponent {
  @Input() userApi: UserAPI;
}
